import React from 'react';
import styled from 'styled-components';
import SectionHeader from '../common/SectionHeader';

const MapSectionContainer = styled.section`
  padding: 80px 0;
`;

const MapWrapper = styled.div`
  position: relative;
  height: 400px;
  border-radius: ${props => props.theme.borders.radius.regular};
  overflow: hidden;
  box-shadow: ${props => props.theme.shadows.regular};
`;

const MapImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const MapOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(44, 62, 80, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: ${props => props.theme.fontWeights.semiBold};
  font-size: ${props => props.theme.fontSizes.medium};
  text-align: center;
  padding: 20px;
`;

const MapSection = () => {
  return (
    <MapSectionContainer>
      <div className="container">
        <SectionHeader 
          title="Our Location" 
          subtitle="Find us on the map" 
        />
        
        <MapWrapper>
          <MapImage src="/placeholder/1200/400" alt="Map Location" />
          <MapOverlay>
            <p>
              Map placeholder - In a production environment, this would be replaced with an actual 
              Google Maps or OpenStreetMap integration showing the location of KALS Academy in Chennai.
            </p>
          </MapOverlay>
        </MapWrapper>
      </div>
    </MapSectionContainer>
  );
};

export default MapSection;
